import { IAiPurchases } from '../global/types';

export function getDayLeft(aiPurchases: IAiPurchases | undefined) {
  const {
    text_sub_expired,
    text_expiration_date,
    img_sub_expired,
    img_expiration_date,
    double_sub_expired,
    double_expiration_date,
  } = aiPurchases || {};

  const textDayLeft =
    (!double_sub_expired && double_expiration_date) ||
    (!text_sub_expired && text_expiration_date);

  const imgDayLeft =
    (!double_sub_expired && double_expiration_date) ||
    (!img_sub_expired && img_expiration_date);

  const doubleDayLeft = !double_sub_expired && double_expiration_date;

  return [textDayLeft, imgDayLeft, doubleDayLeft];
}
